import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    background: theme.extras.variables.colors.faintGray,
    width: '100%',
    height: '4px',
    borderRadius: '2px',
    marginTop: theme.spacing(1),
  },
  barInner: {
    height: '100%',
    borderRadius: '2px',
    display: 'block',
  },
}))

const ProgressBar = ({ ratio, color, className }) => {
  const classes = useStyles()
  return (
    <Box
      className={clsx(
        'progress-bar',
        className,
        classes.root,
      )}
    >
      <Box
        className={classes.barInner}
        sx={{
          width: ratio * 100 + '%',
          background: color,
        }}
      ></Box>
    </Box>
  )
}

export default ProgressBar
